import 'url-search-params-polyfill';
import * as H from 'history';

export const getRedirectLink = (queryString: string): string | null => {
	const urlParams = new URLSearchParams(queryString);
	return urlParams.has('retURL') ? urlParams.get('retURL') : '/';
};

const splitUrl = (url: string): {pathname: string; search: string} => {
	const splitPath = url.split('?');
	const pathname = splitPath[0];
	const search = splitPath[1];
	return {pathname, search};
};

export const getPathNameAndSearch = (): {pathname: string | null; search: string | null} => {
	// Get redirect link
	let pathname = getRedirectLink(window.location.search);
	let search: string | null = null;
	if (pathname?.includes('?')) {
		const urlComponents = splitUrl(pathname);
		pathname = urlComponents.pathname;
		search = urlComponents.search;
	}
	return {pathname, search};
};

const sageThemeUrlMatchers = ['/sage_signup/', '://sage.forecast.', '://sage.wolwa.'];

export const isSageSpecificUrl = (): boolean => {
	return sageThemeUrlMatchers.some(matcher => window.location.href.includes(matcher));
};

// Returns the first occurrence of Tx that is not immediately preceded by "project/" or "program/"
const taskRegexString = '\\/(?<!(project\\/|program\\/))T\\d+';
const taskRegex = new RegExp(taskRegexString);
export const getIndexOfTaskLink = (pathname: string): number => {
	return pathname.search(taskRegex);
};

export const pathIncludesTask = (path: string): boolean => {
	return getIndexOfTaskLink(path) > -1;
};
export const getTaskUrl = (path: string): string => {
	const matches = path.match(taskRegex);
	if (matches) {
		return matches[0];
	}
	return '';
};

const taskRegexReplace = new RegExp(`(.*)(${taskRegexString})(.*)`);
export const removeTaskLinkFromUrl = (path: string): string => {
	return path.replace(taskRegexReplace, '$1$4');
};

export const getTaskPathFromUrlIfExists = (): string => {
	return getTaskUrl(window.location.pathname);
};

export const navigateUnauthorizedCheckTaskLink = (history: H.History): void => {
	const path = window.location.pathname;

	if (pathIncludesTask(path)) {
		const cardPath = path.substring(getIndexOfTaskLink(path), path.length);
		history.push(cardPath);
	} else {
		history.push('/not-authorized');
	}
};
